export default __webpack_public_path__ + "static/media/arbirtum_logo.ec8e5080.svg";